import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pickleball-inauguration',
  templateUrl: './pickleball-inauguration.component.html',
  styleUrls: ['./pickleball-inauguration.component.scss']
})
export class PickleballInaugurationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
